export default "__VITE_ASSET__BcJweh5P__"